// extracted by mini-css-extract-plugin
export default {"CTA":"styles_CTA__J4LpY","float_up":"styles_float_up__78lY1","CTAsmall":"styles_CTAsmall__htdyW","StepHeading":"styles_StepHeading__+l9WY"};